import type { ComputedRef, InjectionKey } from 'vue'

export const FLASHCARD_INTERACTIVE: InjectionKey<ComputedRef<boolean>> =
  Symbol('FLASHCARD_INTERACTIVE')

export const FLASHCARD_FORCE_DARK_MODE: InjectionKey<ComputedRef<boolean>> = Symbol(
  'FLASHCARD_FORCE_DARK_MODE',
)

export const FLASHCARD_AUTOPLAY_AUDIO: InjectionKey<ComputedRef<boolean>> = Symbol(
  'FLASHCARD_AUTOPLAY_AUDIO',
)

export const FLASHCARD_HIDE_AUDIO: InjectionKey<ComputedRef<boolean>> =
  Symbol('FLASHCARD_HIDE_AUDIO')

/** Unconditional hide override — hides audio regardless of autoplay state (e.g. flowchart mode). */
export const FLASHCARD_FORCE_HIDE_AUDIO: InjectionKey<ComputedRef<boolean>> =
  Symbol('FLASHCARD_FORCE_HIDE_AUDIO')

export const FLASHCARD_FORCE_AUDIO_VISIBLE: InjectionKey<ComputedRef<boolean>> = Symbol(
  'FLASHCARD_FORCE_AUDIO_VISIBLE',
)

export const FLASHCARD_DISABLE_AUTOPLAY: InjectionKey<ComputedRef<boolean>> = Symbol(
  'FLASHCARD_DISABLE_AUTOPLAY',
)

export const FLASHCARD_VISIBLE_FACE: InjectionKey<ComputedRef<'front' | 'back'>> =
  Symbol('FLASHCARD_VISIBLE_FACE')

export const FLASHCARD_AUTOFLIP: InjectionKey<ComputedRef<boolean>> = Symbol('FLASHCARD_AUTOFLIP')
